import { MobileChat } from "@faire/help-center-self-serve/components/MobileChat";
import { isMobileApp } from "@faire/help-center-utils/lib/isMobileApp";
import { getBrandToken } from "@faire/help-center-utils/serialized-data/getBrand";
import { getRetailerToken } from "@faire/help-center-utils/serialized-data/getRetailer";
import { getSettingChatEmergencyStop } from "@faire/help-center-utils/settings/getSettingChatEmergencyStop";
import { getSettingChatMobileWebviewEnabled } from "@faire/help-center-utils/settings/getSettingChatMobileWebviewEnabled";
import { trackCxFoundationsChatClick } from "@faire/web-api/events/cxFoundations/click/chat";
import { trackHelpCenterChatOverPhoneClick } from "@faire/web-api/events/helpCenter/click/chatOverPhone";
import React, { useEffect } from "react";
import Smooch from "smooch";
import { useChat } from "../../hooks/useChat";
import { useIssueType } from "../../hooks/useIssueType";
import { useOrderToken } from "../../hooks/useOrderToken";
import { buildMobileChatUrl } from "../../utils/buildMobileChatUrl";
import { isPhoneInBusinessHours } from "../Phone/isPhoneInBusinessHours";
import { usePhoneAuthorization } from "../Phone/usePhoneAuthorization";
import { DesktopChat } from "./DesktopChat";
export var ChatButton = function ChatButton() {
  var _useChat = useChat(),
    setShowChat = _useChat.setShowChat,
    loadingChat = _useChat.loadingChat,
    hasChatAccess = _useChat.hasChatAccess,
    chatBtnEnabled = _useChat.chatBtnEnabled;
  var _useIssueType = useIssueType(),
    issueType = _useIssueType.issueType;
  var _useOrderToken = useOrderToken(),
    orderToken = _useOrderToken.orderToken;
  var _usePhoneAuthorizatio = usePhoneAuthorization(),
    hasPhoneAccess = _usePhoneAuthorizatio.hasPhoneAccess;
  useEffect(function () {
    Smooch.on("widget:closed", function () {
      setShowChat(false);
    });
  }, [setShowChat]);
  if (!hasChatAccess) {
    return null;
  }
  var trackChatClick = function trackChatClick() {
    var _getRetailerToken, _getBrandToken;
    var retailerToken = (_getRetailerToken = getRetailerToken()) !== null && _getRetailerToken !== void 0 ? _getRetailerToken : "";
    var brandToken = (_getBrandToken = getBrandToken()) !== null && _getBrandToken !== void 0 ? _getBrandToken : "";
    if (!chatBtnEnabled) {
      return;
    }
    if (isPhoneInBusinessHours() && hasPhoneAccess) {
      trackHelpCenterChatOverPhoneClick(retailerToken, brandToken, issueType);
    }
    trackCxFoundationsChatClick(retailerToken, brandToken, issueType);
  };
  var handleChatClick = function handleChatClick() {
    trackChatClick();
    setShowChat(true);
  };
  if (isMobileApp() && !getSettingChatMobileWebviewEnabled()) {
    var redirectUrl = buildMobileChatUrl(issueType, orderToken);
    return /*#__PURE__*/React.createElement(MobileChat, {
      to: redirectUrl,
      disableChat: getSettingChatEmergencyStop(),
      loading: loadingChat
    });
  }
  return /*#__PURE__*/React.createElement(DesktopChat, {
    loading: loadingChat,
    onClick: handleChatClick,
    disableChat: getSettingChatEmergencyStop()
  });
};